import { CLOSE_BET_AT } from "../../constants/general";
import { LIST_DRAWING_LO12V2 } from "./types";

const init = {
    countDownTimer: 0,
    isStopBet: false,
    newResult: null,
    oldResult: null,
    active: [],
    closeBet: CLOSE_BET_AT
}


export default (state = init, { type, payload }) => {
    switch (type) {
        case LIST_DRAWING_LO12V2:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
